module.exports = __webpack_public_path__ + "img/public.04925a7c.svg";